import * as React from 'react';
import { DataTable, DateTime } from '@grandvisionhq/common';
import { Heading, Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import DeliveryAddressesSummary from './DeliveryAddressesSummary.js';
import DeliveryAddressForm from './DeliveryAddressForm.js';
import InfoModal from './InfoModal.js';

const Delivery = ({ subscriptionForm , subscription , onChange , onCancel , onSave , onEditModeChange , onModalClose ,  })=>{
    const { getLabel , getFormattedLabel , locale  } = useIntl();
    const sortedDeliveries = subscription.deliveries.sort((l, r)=>r.date.localeCompare(l.date, 'en', {
            numeric: true,
            usage: 'sort'
        })
    );
    const getRow = (rowIndex)=>sortedDeliveries[rowIndex]
    ;
    return /*#__PURE__*/ React.createElement("div", {
        className: "subscription-deliveries"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, getLabel('account.subscription.detail.deliveryDetails')), /*#__PURE__*/ React.createElement(Text, null, getFormattedLabel('account.subscription.detail.deliveryNote', {
        parseLink: true
    })), (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.isInEditMode) ? /*#__PURE__*/ React.createElement(DeliveryAddressForm, {
        onChange: onChange,
        onSave: onSave,
        onCancel: onCancel,
        subscriptionForm: subscriptionForm
    }) : /*#__PURE__*/ React.createElement(DeliveryAddressesSummary, {
        subscription: subscription,
        handleEditClick: ()=>{
            onEditModeChange(true);
        }
    }), /*#__PURE__*/ React.createElement(DataTable, {
        "aria-level": 2,
        caption: getLabel('account.subscription.detail.deliveryHistory'),
        numberOfRows: sortedDeliveries.length
    }, /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "date",
        header: getLabel('common.date')
    }, (rowIndex)=>/*#__PURE__*/ React.createElement(DateTime, {
            locale: locale,
            dateTime: getRow(rowIndex).date
        })
    ), /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "id",
        header: getLabel('account.subscription.detail.deliveryHistory.orderNumber')
    }, (rowIndex)=>getRow(rowIndex).reference || getLabel('common.notAvailable')
    ), /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "boxes_per_eye_side",
        header: getLabel('account.subscription.detail.deliveryHistory.boxesPerEyeSide')
    }, (rowIndex)=>getRow(rowIndex).boxesPerEyeSide || getLabel('common.notAvailable')
    ), /*#__PURE__*/ React.createElement(DataTable.Col, {
        id: "status",
        header: getLabel('account.subscription.detail.delivery.status')
    }, (rowIndex)=>getLabel(`account.subscription.detail.delivery.status.${getRow(rowIndex).status.toLowerCase()}`)
    )), /*#__PURE__*/ React.createElement(InfoModal, {
        isOpen: !!(subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.isModalOpen),
        onModalClose: onModalClose,
        title: getLabel('account.subscription.detail.infoModal.title'),
        message: getLabel('account.subscription.detail.infoModal.message'),
        okLabel: getLabel('common.actions.ok')
    }));
};
var Delivery$1 = Delivery;

export { Delivery, Delivery$1 as default };
//# sourceMappingURL=Delivery.js.map
